<template>
  <v-card outlined class="hmi-setting">
    <div>
      <!-- <div class="text-subtitle-2 tableText--text">Values Type:</div> -->
      <v-chip-group
        @change="onChangeValuesType"
        class="interval-chips"
        mandatory
        column
      >
        <v-chip
          v-for="type in valuesTypes"
          :key="type"
          class="direction-ltr"
          active-class="active-value-type"
          x-small
        >
          {{ type.toUpperCase() }}
        </v-chip>
      </v-chip-group>
    </div>
    <div class="flex-row-between-center">
      <div class="text-subtitle-2 tableText--text">Import CSV:</div>
      <v-file-input
        class="csv-input"
        type="file"
        @change="handleFileUpload"
        accept=".csv"
        dense
        solo
        flat
        prepend-icon=""
        prepend-inner-icon="mdi-import"
        :clearable="false"
      />
    </div>
  </v-card>
</template>

<script>
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import { SET_HMI_PARAMS } from "@/core/services/store/modules/hmi/hmi.module";
import csv from "csv-parser";
import { Readable } from "stream";

export default {
  name: "HMISetting",

  props: {
    recommendation: { type: Boolean },
  },

  data() {
    return {
      valuesTypes: ["default", "latest", "empty"],
      csvData: {},
    };
  },

  methods: {
    onChangeValuesType(typeIndex) {
      this.$store.commit(SET_HMI_PARAMS, {
        type: this.valuesTypes[typeIndex],
        checkEnable: this.recommendation,
      });
    },
    handleFileUpload(file) {
      if (file && file.type === "text/csv") {
        this.parseCsv(file);
      } else {
        this.$store.commit(SET_ALERT, {
          text: this.$t("csvUploadError"),
          isError: true,
        });
      }
    },
    parseCsv(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const readableStream = new Readable();
        readableStream.push(text);
        readableStream.push(null);
        readableStream
          .pipe(csv())
          .on(
            "data",
            (data) =>
              (this.csvData = {
                ...this.csvData,
                [data.parameter]: Number(data.value),
              })
          )
          .on("end", () => {
            this.$store.commit(SET_HMI_PARAMS, {
              type: "empty",
              data: this.csvData,
              checkEnable: this.recommendation,
            });
          });
      };
      reader.readAsText(file);
    },
  },
};
</script>

<style lang="scss">
.hmi-setting {
  direction: ltr;
  position: absolute;
  left: 20px;
  top: 20px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  & .v-slide-group__content {
    padding: 0 !important;
    gap: 5px;
  }
  & .v-chip {
    margin-inline: 0 !important;
  }
  & .active-value-type {
    color: white !important;
    background-color: var(--v-mainBlue-base) !important;
  }

  .csv-input {
    border: 1px solid var(--v-lightGrey-base);
    direction: ltr !important;
    max-width: 85px;
    & .v-input__control {
      min-height: 16px !important;
      max-height: 16px !important;
    }
    & .v-text-field__details {
      display: none;
    }
    & .v-input__slot {
      background-color: var(--v-background-base) !important;
      padding: 0 !important;
      margin: 0 !important;
      min-height: 16px !important;
      max-height: 16px !important;
      border-radius: 2px !important;
    }
    & .v-text-field__suffix {
      font-size: 8px !important;
      color: var(--v-infoGreen-base);
    }
    & .v-file-input__text {
      font-size: 12px !important;
    }
    & input {
      height: 16px;
      max-height: 16px !important;
      font-size: 9px;
      direction: ltr;
    }
    & button {
      font-size: 14px !important;
    }
    & i {
      font-size: 14px;
      margin-left: -10px;
    }
  }
}
</style>
